import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import AxiosPlugin from 'vue-axios-cors'
import store from '../store'

Vue.use(VueAxios, axios)
Vue.use(AxiosPlugin)

export default function setup() {
  axios.interceptors.request.use((config) => {
    store.commit('loadingUpdate', true)
    return config
  })

  axios.interceptors.response.use(
    (res) => {
      store.commit('loadingUpdate', false)
      return res
    },
    (err) => {
      store.commit('loadingUpdate', false)
      return Promise.reject(err)
    },
  )
}
